import React from "react";

export default function ThankYou() {
  return (
    <>
      <div className=" container text-center p-3">
        <h3>Thank you for your enquiry!</h3>
        <h4>We will get back to you ASAP</h4>
      </div>
    </>
  );
}
